import React from 'react';

import { cn } from '@change/ds-utils';

import { Text } from '@change/ds-core-ui/next';

import { Rectangle, SkeletonContainer } from '../../../LoadingSkeletons';

import { rectangleHeights, textSkeletonStylesBlock1, textSkeletonStylesBlock2 } from './constants';
import { FooterStyles } from './Footer.styles';
import type { InstagramPostComponentsProps } from './types';

export function Footer(props: InstagramPostComponentsProps): React.JSX.Element {
	const { loading, message, size } = props;

	const footerStyles = FooterStyles({ size, loading });

	if (loading) {
		return (
			<SkeletonContainer loading={loading} className={footerStyles}>
				<div className="flex flex-col gap-1.5">
					{/*
						Using configuration here instead of style variants from Tailwind for the sake of simplicity
						(otherwise we would  need to create styles for each of the rectangles which is just too much
					*/}
					{textSkeletonStylesBlock1.map((styles) => (
						<Rectangle className={cn(styles[size], rectangleHeights[size])} rounded key={styles.key} />
					))}
				</div>
				<div className="flex flex-col gap-1.5">
					{textSkeletonStylesBlock2.map((styles) => (
						<Rectangle className={cn(styles[size], rectangleHeights[size])} rounded key={styles.key} />
					))}
				</div>
			</SkeletonContainer>
		);
	}

	return (
		<Text as="p" className={footerStyles}>
			{message}
		</Text>
	);
}
